/* OMES · Contactez-nous — behaviour for sections/aide-contact.liquid and reference/contact.html.
   data-demo (reference only) fakes the sent state that Shopify renders server-side via form.posted_successfully?.
   Theme additions (see the section's header): the map keeps OpenStreetMap's attribution; placeChrome() measures the theme's
   fixed mobile toolbar so the fixed submit bar sits above it; data-narrow marks the phone layout for the CSS. */
(function () {
  var root = document.querySelector('[data-aide-page="contact"]');
  if (!root) return;
  var demo = root.hasAttribute('data-demo');
  function $(s) { return root.querySelector(s); }
  function attr(n) { return root.getAttribute('data-' + n) || ''; }
  function lines(v) { return String(v || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean); }
  function out(k, v) { var el = $('[data-aide-text="' + k + '"]'); if (el) el.textContent = v; }
  // Accordions: open on desktop (closed <details> hide their content natively), collapsible when the page is ≤ 900px wide
  var accs = root.querySelectorAll('details.ct-acc'), wide = null;
  function syncAcc() { var w = root.clientWidth > 900; if (w === wide) return; wide = w; root.toggleAttribute('data-narrow', !w); accs.forEach(function (d) { d.open = w; }); }
  if (window.ResizeObserver) new ResizeObserver(syncAcc).observe(root);
  syncAcc();

  // Order number field only for order-related subjects (data-order-subjects, one per line)
  var subject = $('[data-aide="subject"]'), orderWrap = $('[data-state="needsOrder"]'), orderSubjects = lines(attr('order-subjects'));
  function syncOrder() { if (subject && orderWrap) orderWrap.hidden = orderSubjects.indexOf(subject.value) === -1; }
  if (subject) subject.addEventListener('change', syncOrder);
  syncOrder();

  // Character counter
  var msg = $('[data-aide="message"]');
  var max = msg ? Number(msg.getAttribute('maxlength')) || 1000 : 1000;
  function count() { if (msg) out('counter', msg.value.length + ' / ' + max); }
  if (msg) msg.addEventListener('input', count);
  count();

  // Office map (Leaflet 1.9.4 + OpenStreetMap tiles)
  var canvas = $('[data-aide-ref="mapRef"]'), tries = 0;
  function initMap() {
    if (!canvas) return;
    if (!window.L) { if (tries++ < 40) setTimeout(initMap, 250); return; }
    var lat = parseFloat(canvas.getAttribute('data-lat')), lng = parseFloat(canvas.getAttribute('data-lng')), zoom = parseInt(canvas.getAttribute('data-zoom'), 10) || 16;
    if (isNaN(lat) || isNaN(lng)) return;
    var cs = getComputedStyle(root);
    // Attribution on: OpenStreetMap's tile policy requires it (the handoff's open item), so the design's `attributionControl: false` is not kept.
    var map = L.map(canvas, { zoomControl: false, scrollWheelZoom: false, attributionControl: true }).setView([lat, lng], zoom);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', { maxZoom: 19, attribution: '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener">OpenStreetMap</a>' }).addTo(map);
    L.circleMarker([lat, lng], { radius: 8, weight: 2, color: cs.getPropertyValue('--aide-color-ink').trim() || '#1A1A1A', fillColor: cs.getPropertyValue('--aide-color-accent').trim() || '#FF3B26', fillOpacity: 1 }).addTo(map);
    setTimeout(function () { map.invalidateSize(); }, 120);
    var fb = canvas.querySelector('.fallback');
    if (fb) fb.classList.add('gone');
  }
  initMap();

  // Theme chrome: the fixed submit bar (phone) sits above the theme's fixed mobile toolbar (.mbtlwraper), as the privacy page's bar does
  function placeChrome() {
    var tb = document.querySelector('.mbtlwraper'), foot = 0;
    if (tb && getComputedStyle(tb).display !== 'none') foot = tb.getBoundingClientRect().height;
    if (foot) { root.style.setProperty('--aide-mbar-offset', Math.floor(foot) + 'px'); root.setAttribute('data-toolbar', ''); } else root.removeAttribute('data-toolbar');
  }
  window.addEventListener('resize', placeChrome);
  placeChrome();

  if (!demo) return;
  var form = $('[data-state="showForm"]'), sent = $('[data-state="sent"]');
  var submit = $('[data-aide="submit"]'), reset = $('[data-aide="reset"]');
  if (submit) submit.addEventListener('click', function (e) { e.preventDefault(); form.hidden = true; sent.hidden = false; });
  if (reset) reset.addEventListener('click', function (e) { e.preventDefault(); sent.hidden = true; form.hidden = false; if (msg) { msg.value = ''; count(); } });
})();
